import React from "react";
import Loader from 'react-loader-spinner'
import Modal from "../components/Modal";
import StagesManager from "../components/StagesManager";
import { translate } from "../utils/useful";
import AddPermissionHome from "./AddPermission/AddPermissionHome";
import AddPermissionUsers from "./AddPermission/AddPermissionUsers";


class AddPermissionModal extends React.Component {
  state = {
    isLoadingRemove: false,
    id: null,
    index: null
  }

  showModal = (id, index) => {
    this.setState({ id, index })
    this.modal.showModal()
  }

  // hideModal = () => {
  //   this.removeModal.hideModal()
  // }
  onDone=(type)=>{
    this.props.onDone(type)
    this.modal.hideModal()
  }


  render() {
    return (
      <Modal cancelModal={this.props.cancelModal} ref={el => this.modal = el} maxWidth={400} className="flexcc text-center">
        <div className="w-100 h-100 " style={{ backgroundColor: '#fff', borderRadius: 8 }}>


          <StagesManager ref={el => this.stagesManager = el}>
            {/* <AddPermissionUsers stage={0} stageName="home" /> */}
            <AddPermissionHome stage={0} stageName="home" onDone={this.onDone} />
          </StagesManager>



        </div>

      </Modal >
    );
  }
}



export default AddPermissionModal;
